import React, { Component, Fragment } from 'react';
import Modal from 'react-modal';
import { BASE_URL_1 } from '../../../server/constants';
const modalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '60%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
class EmailSelect extends Component{    
    render(){
        return(
        <Fragment>
            <Modal isOpen={this.props.open} style={modalStyles} >
                <div className="modal-header">
                    <h4 className="modal-title modal-title-color">
                    {this.props.title}</h4>
                </div>
                <div className="modal-body">
                <div className="row">
                    <div className="col-md-6">
                    <div className="c_checkbox c_checkbox-inline c_checkbox-primary">                    
                        <input type="checkbox" id={"lbl-all"}
                            checked={this.props.emailList.every(item=>item.selected)} 
                            onChange={(event)=>{  
                                this.props.onSelectionChange(-1,'A',event.currentTarget.checked)                                              
                            }} />
                            <label for={"lbl-all"}>{"Select All"}</label>
                        </div>
                    </div>
                </div>
                    <div className="row">
                    {
                        this.props.emailList.map((rec,k)=>{
                            return <div className="col-md-6">
                                        <div className="c_checkbox c_checkbox-inline c_checkbox-primary">                    
                                            <input type="checkbox" id={"lbl-"+rec.email}
                                            checked={rec.selected} onChange={(event)=>{ 
                                                this.props.onSelectionChange(k,'S',event.currentTarget.checked)                                               
                                            }} />
                                            <label for={"lbl-"+rec.email}>{rec.email}</label>
                                        </div></div>
                        })
                    }
                    </div>
                        
                </div>
                <div className="text-right">
                    <button type="button" className="btn btn-danger btn-xs" style={{ margin: '0 0 0 5px' }} onClick={()=>{
                           // this.setState({showModal:false})
                        }} onClick={(e)=>{this.props.onCancel(e)}}><i className="fa fa-times"></i> Cancel
                    </button>
                    <button type="button" className="btn btn-success btn-xs" disabled={!this.props.emailList.some(item=>item.selected)}
                        style={{ margin: '0 0 0 5px' }} onClick={(e)=>{
                           this.props.onSubmit(e)
                        }}><i className="fa fa-check"></i> Submit
                    </button>
                </div>
            </Modal>
        </Fragment>)
    }

}
export default EmailSelect


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/ManagePayments/EmailSelect.jsx